import { Map } from 'immutable'
import createNamedActions from './actions.subscriptions'

const initialState = {
  subscriptionStates: Map(),
}

const createNamedReducer = (namespace) => {
  const { actionNames } = createNamedActions(namespace)

  return (state = initialState, action = undefined) => {
    switch (action.type) {
      case actionNames.TOGGLE_FOLLOW_ENTITY_PROGRESS: {
        const { identifier, identifierType } = action
        const currentSubscriptionStates = state.subscriptionStates
        const newSubscriptionState = {
          status: 'pending',
          type: identifierType,
        }
        return {
          ...state,
          subscriptionStates: currentSubscriptionStates.set(
            identifier,
            newSubscriptionState
          ),
        }
      }
      case actionNames.FOLLOW_ENTITY_SUCCESS: {
        const { identifier, identifierType } = action
        const currentSubscriptionStates = state.subscriptionStates
        const newSubscriptionState = {
          status: 'following',
          type: identifierType,
        }
        return {
          ...state,
          subscriptionStates: currentSubscriptionStates.set(
            identifier,
            newSubscriptionState
          ),
        }
      }
      case actionNames.UNFOLLOW_ENTITY_SUCCESS: {
        const { identifier } = action
        const currentSubscriptionStates = state.subscriptionStates

        return {
          ...state,
          subscriptionStates: currentSubscriptionStates.remove(identifier),
        }
      }
      case actionNames.FOLLOW_ENTITY_FAILURE:
      case actionNames.UNFOLLOW_ENTITY_FAILURE: {
        const { identifier, identifierType } = action
        const currentSubscriptionStates = state.subscriptionStates
        const newSubscriptionState = {
          status: 'failed',
          type: identifierType,
        }
        return {
          ...state,
          subscriptionStates: currentSubscriptionStates.set(
            identifier,
            newSubscriptionState
          ),
        }
      }
      case actionNames.FETCH_SUBSCRIBERS_SUCCESS: {
        const {
          data: { subscriptions },
        } = action
        const subscriptionStates = subscriptions.reduce((acc, subscription) => {
          acc[subscription.identifier] = {
            status: 'following',
            type: subscription.type,
          }
          return acc
        }, {})

        return { ...state, subscriptionStates: Map(subscriptionStates) }
      }
      default:
        return state
    }
  }
}

export default createNamedReducer
